import React from 'react';

interface ComponentHealthProps {
  name: string;
  healthy: boolean;
  uptime?: number;
}

function formatUptime(seconds: number): string {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (days > 0) {
    return `${days}d ${hours}h`;
  } else if (hours > 0) {
    return `${hours}h ${minutes}m`;
  } else {
    return `${minutes}m`;
  }
}

export function ComponentHealth({
  name,
  healthy,
  uptime,
}: ComponentHealthProps) {
  return (
    <div className="bg-white rounded-lg p-6 border border-gray-200 hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-900">{name}</h3>
        <div
          className={`w-3 h-3 rounded-full ${
            healthy ? 'bg-green-500' : 'bg-red-500'
          }`}
        />
      </div>
      <div className="mt-4">
        <p
          className={`text-sm font-medium ${
            healthy ? 'text-green-600' : 'text-red-600'
          }`}
        >
          {healthy ? 'Healthy' : 'Unhealthy'}
        </p>
        {uptime !== undefined && (
          <p className="text-xs text-gray-500 mt-1">
            Uptime: {formatUptime(uptime)}
          </p>
        )}
      </div>
    </div>
  );
}
